// extracted by mini-css-extract-plugin
module.exports = {"Container":"DropArea_Container__TkwX2","Overlay":"DropArea_Overlay__EDpeD","Hovered":"DropArea_Hovered__Qodf7"};